import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sheet_default-icon",
  "use": "icon-sheet_default-icon-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-sheet_default-icon\"><g transform=\"translate(1 2)\" stroke=\"currentColor\" fill=\"transparent\" stroke-width=\"1.5\"><rect x=\".75\" y=\".75\" width=\"14.5\" height=\"17.5\" rx=\"2\" /><path d=\"M14.903 8h4.347c.966 0 1.75.995 1.75 2.222V16.1c0 1.227-.784 2.128-1.75 2.128H14\" /><path stroke-linecap=\"round\" d=\"M4.32 5h4M4.32 9.5h8M4.32 14h8\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol